<template>
  <div class="x-tablelist-view">
    <!-- 搜索行 -->
    <!-- <my-search-option
      class="language-option"
      :layout="layout"
      :data="searchData"
      :isBreak="true"
      @clickSearch="search"
      @clear="clear"
    ></my-search-option> -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="search"
      @add="onclickAdd"
      @resetsearch="clear"
    ></ux-searchOption>
    <!-- <div class="language-center">
      <ux-button type="primary" icon="ux_icon_plus" @click="onclickAdd"> {{ $t('HT.add') }}</ux-button>
      <span class="language-total">{{
        $t('HT.orderOverview.total', { total: tableData.totalSize })
      }}</span>
    </div> -->

    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        class="language-table"
        ref="table"
        maxHeight="100%"
        layout="total, sizes, prev, pager, next"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size="tableData.size"
        :page.sync="tableData.page"
        :emptyText="$t('HT.nodata')"
        @changePage="changePage"
        @changeSize="changeSize"
      ></ux-table>
    </div>

    <!-- 绑定邮箱 -->
    <add-lang
      v-if="modalData.isShow"
      :info="modalData.info"
      @update-info="search"
      @close="modalData.isShow = false"
    ></add-lang>
  </div>
</template>

<script>
import mySearchOption from '@c/mySearchOption/mySearchOption';
import myPopconfirm from '@c/myPopconfirm/myPopconfirm';
import addLang from './modal/addLang.vue';

export default {
  components: {
    mySearchOption,
    myPopconfirm,
    addLang
  },
  data() {
    return {
      layout: [
        {
          width: '272px',
          type: 'input',
          key: 'key',
          hideBtn: true,
          placeholder: this.$t('key')
        },
        {
          width: '272px',
          type: 'input',
          key: 'zhValue',
          hideBtn: true,
          placeholder: this.$t('中文信息')
        },
        {
          width: '100px',
          type: 'select',
          key: 'keyType',
          hideBtn: true,
          placeholder: this.$t('类型'),
          options: [
            {
              label: this.$t('前端'),
              value: 1
            },
            {
              label: this.$t('后端'),
              value: 0
            }
          ]
        },
        {
          type: 'button',
          text: this.$t('HT.search'),
          show: true,
          event: 'search',
          spacing: '20px'
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          right: true,
          event: 'add'
        }
      ],
      filter: {
        key: '', // key 名称
        keyType: '', // key 类型
        zhValue: '', // 中文名
        page: 1,
        size: 10
      },
      modalData: {
        isShow: false,
        info: null
      },
      id: this.$store.state.login.userData.id, // id
      ownerData: {}, //用户信息
      payTypeOption: this.$opt.payType, // 支付方式下拉框
      orderStatusOption: this.$opt.orderStatus, // 订单状态下拉框
      countDownTimer: null, // 倒计时
      countDownList: [], // 倒计时数据
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      saveSearchData: {}, // 保存搜索数据
      columns: [
        // 表头数据
        { prop: 'key', label: 'key', tooltip: true, align: 'left' },
        {
          label: this.$t('HT.upgrade.type'),
          tooltip: true,
          align: 'left',
          render: (h, row) => {
            const typeMap = {
              1: this.$t('HT.options.frontEnd'),
              2: this.$t('HT.options.afterEnd')
            };
            return h('span', {}, typeMap[row.key_type]);
          }
        },
        {
          prop: 'key_scene',
          label: this.$t('HT.language.scene'),
          tooltip: true,
          align: 'left',
          render: (h, row) => {
            const sceneMap = {
              1: this.$t('HT.options.console'),
              2: this.$t('HT.options.official')
            };
            return h('span', {}, sceneMap[row.key_scene]);
          }
        },
        {
          prop: 'en_value',
          label: this.$t('HT.language.en'),
          tooltip: true,
          align: 'left',
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          prop: 'zh_value',
          label: this.$t('HT.language.zh'),
          tooltip: true,
          align: 'left',
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.operation'),
          tooltip: true,
          align: 'left',
          render: (h, row) => {
            return h('span', {}, [
              h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  style: {
                    'margin-right': '8px'
                  },
                  on: {
                    click: () => {
                      this.onclickEdit(row);
                    }
                  }
                },
                this.$t('HT.edit')
              ),
              h(
                myPopconfirm,
                {
                  props: {
                    width: '240px',
                    confirmButtonType: 'danger',
                    confirmButtonText: this.$t('HT.delete'),
                    title: this.$t('HT.language.delTitle'),
                    placement: 'left-end'
                  },
                  on: {
                    onConfirm: () => {
                      this.onclickDel(row);
                    }
                  }
                },
                [
                  h(
                    'ux-button',
                    {
                      props: {
                        type: 'danger',
                        text: true
                      },
                      slot: 'reference'
                    },
                    this.$t('HT.delete')
                  )
                ]
              )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    this.ownerData = this.$store.state.login.userData;
    // document.querySelector('.language-table .ux-pagination').classList.remove('is-background');
    this.search();
  },

  methods: {
    onclickEdit(row) {
      this.modalData.info = row;
      this.modalData.isShow = true;
    },
    onclickAdd() {
      this.modalData.info = {};
      this.modalData.isShow = true;
    },
    onclickDel(row) {
      this.$api.language.delI18n(row.id).then((res) => {
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          this.search();
        }
      });
    },
    // 格式化参数
    formatParams() {
      const { size, page, key, keyType, zhValue } = this.saveSearchData;
      const params = {
        size,
        page,
        key,
        keyType,
        zhValue
      };
      return params;
    },
    // 获取列表
    getList() {
      const params = this.formatParams();
      this.$uxLoading.show();
      this.$api.language.getI18nList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData.list = res.data || [];
          this.tableData.totalSize = res.total_size || 0;
        }
      });
    },

    /**
     * 搜索
     */
    search() {
      this.tableData.page = 1;
      this.saveSearchData = JSON.parse(JSON.stringify(this.filter));
      this.getList();
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.search();
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.search();
    },
    clear() {
      const params = {
        key: '', // key 名称
        keyType: '', // key 类型
        zhValue: '', // 中文名
        page: 1,
        size: 10
      };
      Object.assign(this.filter, params);
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.x-tablelist-view.language {
  height: 100%;
  margin: 0;
  background: none;
  border: none;
  padding: 20px 40px 0 20px;

  .language-option {
    padding: 32px 40px 16px;
    margin-bottom: 30px;
    background: #fff;
    border-radius: 8px;
  }

  .language-center {
    height: 54px;

    .language-total {
      margin-left: 20px;
      color: $color-text-secondary;
      height: 20px;
      line-height: 20px;
    }
  }

  ::v-deep .language-table .ux-pagination {
    text-align: right;
    padding: 20px 0 32px;

    .btn-next,
    .btn-prev {
      height: 32px;
      background: transparent;
    }

    .el-pager {
      .el-icon-more,
      .number,
      .btn-quicknext:hover {
        height: 32px;
        line-height: 32px;
        background: transparent;
      }
    }

    .el-pagination__sizes .el-select .el-input {
      .el-input__inner {
        border: none;
        background: transparent;
      }
    }
  }
}
</style>
